// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-container {
    padding: 50px 0px 0px;
    min-height: 100vh;
}

.project-disc h1{
    font-size: 60px;
    color: var(--text-color-2);
    margin-bottom: 20px;
}

.project-parent {
    padding: 0 50px;
}

.project-disc p {
    font-size: 20px;
    color: var(--text-color-3); 
    margin-bottom: 30px;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
}

.project-holder {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.project-card {
    margin: 12px 0px;
    margin-right: 15px;
    width: 32%;
    height: 210px;
    background-color: var(--app-color-1);
    box-shadow: 1px 1px 2px 1px var(--app-color-2);
    border-style: solid;
    border-top-color: var(--app-color-4);
    display: flex;
    justify-content: center;
    align-items: center;
}

.project-card-contained {
    width: 90%;
    height: 90%;
}

.project-card h4 {
    margin-top: 35px;
    color: var(--text-color-2);
    font-size: 15px;
}

.project-card h1 {
    color: var(--text-color-3);
}

.project-card h1 a{
    text-decoration: none;
    color: inherit;
    transition: color 0.2s;
}

.project-card h1 a:hover{
    color: var(--app-color-4);
}

.project-card p {
    color: var(--app-color-3);
}

@media screen and (max-width: 1500px) {
    .project-card h1 {
        font-size: 30px;
    }
    .project-card {
        margin-right: 10px;
    }
}

@media screen and (max-width: 1100px) {
    .project-card h1 {
        font-size: 20px;
    }
}

@media screen and (max-width: 850px) {
    .project-card {
        width: 48%;
    }
}

@media screen and (max-width: 700px) {
    .project-disc h1 {
        font-size: 40px;
    }
    .project-disc p {
        font-size: 15px;
    }
}

@media screen and (max-width: 650px) {
    .project-card {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Mainbody/Projects/Projects.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,oCAAoC;IACpC,8CAA8C;IAC9C,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".project-container {\r\n    padding: 50px 0px 0px;\r\n    min-height: 100vh;\r\n}\r\n\r\n.project-disc h1{\r\n    font-size: 60px;\r\n    color: var(--text-color-2);\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.project-parent {\r\n    padding: 0 50px;\r\n}\r\n\r\n.project-disc p {\r\n    font-size: 20px;\r\n    color: var(--text-color-3); \r\n    margin-bottom: 30px;\r\n}\r\n\r\n.flex-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.project-holder {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.project-card {\r\n    margin: 12px 0px;\r\n    margin-right: 15px;\r\n    width: 32%;\r\n    height: 210px;\r\n    background-color: var(--app-color-1);\r\n    box-shadow: 1px 1px 2px 1px var(--app-color-2);\r\n    border-style: solid;\r\n    border-top-color: var(--app-color-4);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.project-card-contained {\r\n    width: 90%;\r\n    height: 90%;\r\n}\r\n\r\n.project-card h4 {\r\n    margin-top: 35px;\r\n    color: var(--text-color-2);\r\n    font-size: 15px;\r\n}\r\n\r\n.project-card h1 {\r\n    color: var(--text-color-3);\r\n}\r\n\r\n.project-card h1 a{\r\n    text-decoration: none;\r\n    color: inherit;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.project-card h1 a:hover{\r\n    color: var(--app-color-4);\r\n}\r\n\r\n.project-card p {\r\n    color: var(--app-color-3);\r\n}\r\n\r\n@media screen and (max-width: 1500px) {\r\n    .project-card h1 {\r\n        font-size: 30px;\r\n    }\r\n    .project-card {\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n    .project-card h1 {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 850px) {\r\n    .project-card {\r\n        width: 48%;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n    .project-disc h1 {\r\n        font-size: 40px;\r\n    }\r\n    .project-disc p {\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n    .project-card {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
